import type React from 'react';

import { cn } from '~/lib/cn';

interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  children?: React.ReactNode;
}

export function Badge({ children, className, ...props }: BadgeProps) {
  return (
    <span
      className={cn(
        'absolute right-0 top-0 min-w-md -translate-y-1/2 translate-x-1/2 rounded-full px-sm py-xs text-caption-md font-bold bg-primary-default text-white',
        className,
      )}
      {...props}
    >
      {children}
    </span>
  );
}

Badge.displayName = 'Badge';
